import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

export const UserDetailsResponseSchema = z.array(
  z.object({
    id: z.number(),
    firstName: z.string(),
    lastName: z.string(),
  }),
);

export const getUserDetails = defaultClient.query({
  url: 'authentication/v1/users/summary/' as const,
  method: 'GET',
  querySchema: z.object({
    ids: z.string(),
  }),
  responseSchema: UserDetailsResponseSchema,
  processResponse(data) {
    return data[0];
  },
});
